export const REACT_APP_INSTAGRAM_ACCESS_TOKEN="IGAGXpGgs3s6ZABZAFE4aFNra01EM1U4UTVaeTQ4eW1DZA1FUYnRyUElqVzRGZAkFIRlRtYmw0eEtUb2UxbmJDWFpiQWRjdGtkazlfdVE1SzdJQ3F2LWdkLVBJVkV2NUY0aTVvTUR4VkxPQTFnVzlTZAFBlUU4xd1FwUXJwZAnFtUzZACYwZDZD"

export const REACT_APP_API_URL=process.env.REACT_APP_API_URL || "http://localhost:5000";

